import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Form, Pagination, InputGroup, Image, Modal } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import axios from 'axios';
import { BsTrash, BsPencilSquare, BsToggleOff, BsToggleOn } from 'react-icons/bs';
import { API_ENDPOINTS } from '../config';
 
const defaultProfilePic = "/images/avatar.png";

const Providers = () => {
  const [providers, setProviders] = useState([]);
  const [editingProvider, setEditingProvider] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [providersPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [editPasswordUser, setEditPasswordUser] = useState(null);


    

  useEffect(() => {
    fetchProviders();
  }, []);
//console.log("------",providers)
  const fetchProviders = async () => {
    try {
      const token = localStorage.getItem('token');
      //console.log("Fetching providers with token:", token); // Added log
      const response = await axios.get(API_ENDPOINTS.getAllProviders, {
        headers: { token },
      });
     // console.log("Providers fetched successfully:", response.data); // Added log
      setProviders(response.data.providerBusinessesData);
    } catch (error) {
      console.error('Error fetching providers:', error);
    }
  };

  const handleEditProvider = (provider) => {
    //console.log("Editing provider:", provider); // Added log
    setEditingProvider(provider);
  };

  const handleEditChange = (e) => {
    //console.log("Edit field changed:", e.target.name, e.target.value); // Added log
    setEditingProvider({ ...editingProvider, [e.target.name]: e.target.value });
  };


    const handleChangePasswordUser = (user) => {
      //console.log("--",user);
      setEditPasswordUser(user);
      setShowChangePasswordModal(true);
    };


    const handleSavePassword = async () => {
        try {
         
         await axios.patch(API_ENDPOINTS.changepasswordProvider, editPasswordUser, {
            headers: {
              'token': localStorage.getItem('token'),
            }
          });

          setShowChangePasswordModal(false);
         fetchProviders();
        } catch (error) {
          console.error('Error updating user:', error);
        }
      };


  const saveProviderDetails = async () => {
    try {
      const token = localStorage.getItem('token');
      const { providerId, orgName, providerRole, consultantfee, isAvailable } = editingProvider;
    //console.log("--ee-",editingProvider)
   
      const endpoint = API_ENDPOINTS.editProviderBusiness;
      //console.log("API Endpoint:", endpoint); // Log the endpoint

      const headers = {
        token,
        providerId, // Include providerId in headers
      };
      //console.log("Request Headers:", headers); // Added log

      const response = await axios.patch(
        endpoint,
        { orgName, providerRole, consultantfee,isAvailable },
        { headers }
      );
      //console.log("Provider updated successfully:", response.data); // Added log

      setEditingProvider(null);
      fetchProviders();
    } catch (error) {
      console.error('Error updating provider details:', error.response?.data || error.message);
    }
  };
  /*
  const toggleUserActiveStatus = async (providerId) => {
    try {
      const token = localStorage.getItem('token');
      console.log("===",providerId); // Added log 
      const response = await axios.post(
        API_ENDPOINTS.toggleUserActiveStatus,
        { providerId }, 
        { headers: { token } }
      );
      console.log("User status toggled:", response.data.success); // Added log
      fetchProviders();
    } catch (error) {
      console.error('Error toggling user status:', error);
    }
  };*/

  const handleDeleteProvider = async (providerId) => {
    if (window.confirm('Are you sure you want to delete this provider?')) {
      try {
        const token = localStorage.getItem('token');
        console.log("Deleting provider with providerId:", providerId); // Added log
        await axios.delete(API_ENDPOINTS.deleteProvider, {
          headers: { token },
          data: { providerId },
        });
        fetchProviders();
      } catch (error) {
        console.error('Error deleting provider:', error);
      }
    }
  };

  const filteredProviders = providers.filter(
    (provider) =>
      provider.providerId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      provider.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      provider.orgName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastProvider = currentPage * providersPerPage;
  const indexOfFirstProvider = indexOfLastProvider - providersPerPage;
  const currentProviders = filteredProviders.slice(indexOfFirstProvider, indexOfLastProvider);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="d-flex">
      <Sidebar style={{ position: 'fixed', top: 0, bottom: 0, left: 0, width: '250px', zIndex: 1000 }} />
      <div style={{ width: 'calc(100%)', height: 'calc(100vh)', overflowY: 'auto' }}>
        <Header style={{ position: 'fixed', top: 0, left: '250px', width: 'calc(100% - 250px)', zIndex: 1000 }} />
        <Container fluid className="mt-3">
          <Row>
            <Col>
              <InputGroup className="mb-3">
                <Form.Control
                  placeholder="Search providers..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Profile Picture </th>
                    <th>Provider ID</th>
                    <th>Name</th>
                    <th>Organization</th>
                    <th>Role</th>
                    <th>Consultant Fee</th>
                    <th>Availability</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentProviders.map((provider) => (
                    <tr key={provider._id}>
                      <td>
                        <Image
                          src={provider.profilePic || defaultProfilePic}
                          alt="Profile"
                          style={{ width: '80px', height: '80px' }}
                        />
                      </td>
                      <td>{provider.providerId}</td>
                      <td>{provider.userName}</td>
                      <td>{provider.orgName || 'N/A'}</td>
                      <td>{provider.providerRole}</td>
                      <td>{provider.consultantfee || 'N/A'}</td>
                      <td>
                        {provider.isAvailable == true ? (
                          <span>Available</span>
                        ) : (
                          <span>Not Available</span>
                        )}
                      </td>
                      <td>
                        <Button variant="warning" onClick={() => handleEditProvider(provider)}>
                          <BsPencilSquare />
                        </Button>{' '}
                         <Button variant="info" onClick={() => handleChangePasswordUser(provider)} className="me-2">
                            Change Password
                          </Button>
                          
                       {/*  <Button variant="danger" onClick={() => handleDeleteProvider(provider.providerId)}>
                          <BsTrash />
                        </Button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Pagination>
                {[...Array(Math.ceil(filteredProviders.length / providersPerPage)).keys()].map((number) => (
                  <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
                    {number + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </Col>
          </Row>
        </Container>

        {editingProvider && (
          <Modal show onHide={() => setEditingProvider(null)}>
            <Modal.Header closeButton>
              <Modal.Title>Edit Provider</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId="providerRole">
                  <Form.Label>Role</Form.Label>
                  <Form.Control
                    type="text"
                    name="providerRole"
                    value={editingProvider.providerRole}
                    onChange={handleEditChange}
                  />
                </Form.Group>
                <Form.Group controlId="organization">
                  <Form.Label>Organization</Form.Label>
                  <Form.Control
                    type="text"
                    name="orgName"
                    value={editingProvider.orgName}
                    onChange={handleEditChange}
                  />
                </Form.Group>
                <Form.Group controlId="consultantfee">
                  <Form.Label>Consultant Fee</Form.Label>
                  <Form.Control
                    type="number"
                    name="consultantfee"
                    value={editingProvider.consultantfee || ''}
                    onChange={handleEditChange}
                  />
                </Form.Group>
                <Form.Group controlId="isAvailable" className="mt-2">
                <Form.Label>Availability</Form.Label>
                  <Form.Control
                      as="select"
                      name="isAvailable"
                      value={editingProvider.isAvailable}
                      onChange={handleEditChange}
                    >
                      <option value="true">Available</option>
                      <option value="false">Not Available</option>
                    </Form.Control>
                  </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setEditingProvider(null)}>
                Cancel
              </Button>
              <Button variant="primary" onClick={saveProviderDetails}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>

        )}

         { /* ----------------- Change Password */ }
                <Modal show={showChangePasswordModal} onHide={() => setShowChangePasswordModal(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>Changes Password</Modal.Title> 
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <Form.Group>
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="text"
                        name="password"
                      
                        onChange={(e) => setEditPasswordUser({...editPasswordUser,password: e.target.value })}
                         
                      />
                    </Form.Group>
                    
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowChangePasswordModal(false)}>Cancel</Button>
                  <Button variant="primary" onClick={handleSavePassword}>Save Changes</Button>
                </Modal.Footer>
              </Modal>
      </div>
    </div>
  );
};

export default Providers;
